// This file is auto generated by scripts/generate-paths
// Do not edit this file directly.


const buildSuffix = (url?: {
  query?: Record<string, string | number | boolean | undefined | null | Array<string | number | boolean | undefined | null>>,
  hash?: string
}) => {
  const query = url?.query;
  const hash = url?.hash;
  if (!query && !hash) return '';
  const search = (() => {
    if (!query) return '';

    const params = new URLSearchParams();

    Object.entries(query).forEach(([key, value]) => {
      if (value == null) return;
      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item == null) return;
          params.append(key, String(item))
        });
      } else {
        params.set(key, String(value));
      }
    });

    return `?${params.toString()}`;
  })();
  return `${search}${hash ? `#${hash}` : ''}`;
};

export const buildPaths = (pathInterceptor = (path: string) => path) => ({
  'admin': {
    'auth': {
      'callback': {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/auth/callback' as const, hash: url?.hash, path: pathInterceptor(`/admin/auth/callback${buildSuffix(url)}`) }),
      },
    },
    'list': {
      'applications': {
        'fuufukyoudoufuyoukakunin': {
          _applicationId: (applicationId: string | number) => ({
            'files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/fuufukyoudoufuyoukakunin/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/fuufukyoudoufuyoukakunin/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
              }),
            },
          }),
        },
        'hifuyoushashikakukakunin': {
          _applicationId: (applicationId: string | number) => ({
            'files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/hifuyoushashikakukakunin/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/hifuyoushashikakukakunin/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
              }),
            },
          }),
        },
        'hihuyousyaidoutodoke': {
          _applicationId: (applicationId: string | number) => ({
            'files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/hihuyousyaidoutodoke/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/hihuyousyaidoutodoke/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
              }),
            },
          }),
        },
        'ryoyohitatekae': {
          _applicationId: (applicationId: string | number) => ({
            'admin_files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/admin-files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/admin-files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
                'preview': {
                  $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/admin-files/[fileId]/preview' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/admin-files/${encodeURIComponent(fileId)}/preview${buildSuffix(url)}`) }),
                },
              }),
            },
            'details': {
              _detailId: (detailId: string | number) => ({
                'admin_files': {
                  _fileId: (fileId: string | number) => ({
                    $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/details/[detailId]/admin-files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/details/${encodeURIComponent(detailId)}/admin-files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
                    'preview': {
                      $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/details/[detailId]/admin-files/[fileId]/preview' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/details/${encodeURIComponent(detailId)}/admin-files/${encodeURIComponent(fileId)}/preview${buildSuffix(url)}`) }),
                    },
                  }),
                },
                'submitted_files': {
                  _fileId: (fileId: string | number) => ({
                    $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/details/[detailId]/submitted-files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/details/${encodeURIComponent(detailId)}/submitted-files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
                    'preview': {
                      $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/details/[detailId]/submitted-files/[fileId]/preview' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/details/${encodeURIComponent(detailId)}/submitted-files/${encodeURIComponent(fileId)}/preview${buildSuffix(url)}`) }),
                    },
                  }),
                },
              }),
            },
            'download': {
              $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/download' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/download${buildSuffix(url)}`) }),
              'details': {
                _detailId: (detailId: string | number) => ({
                  $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/download/details/[detailId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/download/details/${encodeURIComponent(detailId)}${buildSuffix(url)}`) }),
                }),
              },
              'subject_information': {
                $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/ryoyohitatekae/[applicationId]/download/subject-information' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/download/subject-information${buildSuffix(url)}`) }),
              },
            },
          }),
        },
        'shussanteatekin': {
          _applicationId: (applicationId: string | number) => ({
            'submitted_files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/applications/shussanteatekin/[applicationId]/submitted-files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/applications/shussanteatekin/${encodeURIComponent(applicationId)}/submitted-files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
              }),
            },
          }),
        },
      },
      'medical_checkups': {
        'results': {
          'reports': {
            'monthly': {
              $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/medical-checkups/results/reports/monthly' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/medical-checkups/results/reports/monthly${buildSuffix(url)}`) }),
            },
          },
          'subsidy_docs': {
            'pdf': {
              _officeId: (officeId: string | number) => ({
                _fiscalYear: (fiscalYear: string | number) => ({
                  _paymentDate: (paymentDate: string | number) => ({
                    $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/medical-checkups/results/subsidy-docs/pdf/[officeId]/[fiscalYear]/[paymentDate]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/medical-checkups/results/subsidy-docs/pdf/${encodeURIComponent(officeId)}/${encodeURIComponent(fiscalYear)}/${encodeURIComponent(paymentDate)}${buildSuffix(url)}`) }),
                  }),
                }),
              }),
            },
          },
        },
      },
      'notification_papers': {
        'benefit_determination_dates': {
          'download_notification_paper': {
            _notificationPaperId: (notificationPaperId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/notification-papers/benefit-determination-dates/download-notification-paper/[notificationPaperId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/notification-papers/benefit-determination-dates/download-notification-paper/${encodeURIComponent(notificationPaperId)}${buildSuffix(url)}`) }),
            }),
          },
          'files': {
            _uploadType: (uploadType: string | number) => ({
              _uploadId: (uploadId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/admin/list/notification-papers/benefit-determination-dates/files/[uploadType]/[uploadId]' as const, hash: url?.hash, path: pathInterceptor(`/admin/list/notification-papers/benefit-determination-dates/files/${encodeURIComponent(uploadType)}/${encodeURIComponent(uploadId)}${buildSuffix(url)}`) }),
              }),
            }),
          },
        },
      },
    },
  },
  'auth': {
    'callback': {
      $url: (url?: { hash?: string }) => ({ pathname: '/auth/callback' as const, hash: url?.hash, path: pathInterceptor(`/auth/callback${buildSuffix(url)}`) }),
    },
  },
  'employers': {
    _officeId: (officeId: string | number) => ({
      'applications': {
        'download_notification_paper': {
          _notificationPaperId: (notificationPaperId: string | number) => ({
            $url: (url?: { hash?: string }) => ({ pathname: '/employers/[officeId]/applications/download-notification-paper/[notificationPaperId]' as const, hash: url?.hash, path: pathInterceptor(`/employers/${encodeURIComponent(officeId)}/applications/download-notification-paper/${encodeURIComponent(notificationPaperId)}${buildSuffix(url)}`) }),
          }),
        },
        'fuufukyoudoufuyoukakunin': {
          _applicationId: (applicationId: string | number) => ({
            'files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/employers/[officeId]/applications/fuufukyoudoufuyoukakunin/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/employers/${encodeURIComponent(officeId)}/applications/fuufukyoudoufuyoukakunin/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
              }),
            },
          }),
        },
        'hifuyoushashikakukakunin': {
          _applicationId: (applicationId: string | number) => ({
            'files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/employers/[officeId]/applications/hifuyoushashikakukakunin/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/employers/${encodeURIComponent(officeId)}/applications/hifuyoushashikakukakunin/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
              }),
            },
          }),
        },
        'hihuyousyaidoutodoke': {
          _applicationId: (applicationId: string | number) => ({
            'files': {
              _fileId: (fileId: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/employers/[officeId]/applications/hihuyousyaidoutodoke/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/employers/${encodeURIComponent(officeId)}/applications/hihuyousyaidoutodoke/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
              }),
            },
          }),
        },
      },
      'medical_checkups': {
        _fiscalYear: (fiscalYear: string | number) => ({
          'results': {
            'pdf': {
              _paymentDate: (paymentDate: string | number) => ({
                $url: (url?: { hash?: string }) => ({ pathname: '/employers/[officeId]/medical-checkups/[fiscalYear]/results/pdf/[paymentDate]' as const, hash: url?.hash, path: pathInterceptor(`/employers/${encodeURIComponent(officeId)}/medical-checkups/${encodeURIComponent(fiscalYear)}/results/pdf/${encodeURIComponent(paymentDate)}${buildSuffix(url)}`) }),
              }),
            },
          },
        }),
      },
      'office_members': {
        $url: (url?: { hash?: string }) => ({ pathname: '/employers/[officeId]/office_members' as const, hash: url?.hash, path: pathInterceptor(`/employers/${encodeURIComponent(officeId)}/office_members${buildSuffix(url)}`) }),
      },
    }),
    'auth': {
      'callback': {
        $url: (url?: { hash?: string }) => ({ pathname: '/employers/auth/callback' as const, hash: url?.hash, path: pathInterceptor(`/employers/auth/callback${buildSuffix(url)}`) }),
      },
    },
    'zendesk': {
      'logout': {
        $url: (url?: { hash?: string }) => ({ pathname: '/employers/zendesk/logout' as const, hash: url?.hash, path: pathInterceptor(`/employers/zendesk/logout${buildSuffix(url)}`) }),
      },
      'redirect': {
        $url: (url?: { hash?: string }) => ({ pathname: '/employers/zendesk/redirect' as const, hash: url?.hash, path: pathInterceptor(`/employers/zendesk/redirect${buildSuffix(url)}`) }),
      },
    },
  },
  'members': {
    'applications': {
      'benefit_notification_papers': {
        _notificationPaperId: (notificationPaperId: string | number) => ({
          'download': {
            $url: (url?: { hash?: string }) => ({ pathname: '/members/applications/benefit-notification-papers/[notificationPaperId]/download' as const, hash: url?.hash, path: pathInterceptor(`/members/applications/benefit-notification-papers/${encodeURIComponent(notificationPaperId)}/download${buildSuffix(url)}`) }),
          },
        }),
      },
      'download_notification_paper': {
        _notificationPaperId: (notificationPaperId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/members/applications/download-notification-paper/[notificationPaperId]' as const, hash: url?.hash, path: pathInterceptor(`/members/applications/download-notification-paper/${encodeURIComponent(notificationPaperId)}${buildSuffix(url)}`) }),
        }),
      },
      'fuufukyoudoufuyoukakunin': {
        _applicationId: (applicationId: string | number) => ({
          'files': {
            _fileId: (fileId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/members/applications/fuufukyoudoufuyoukakunin/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/members/applications/fuufukyoudoufuyoukakunin/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
            }),
          },
        }),
      },
      'hifuyoushashikakukakunin': {
        _applicationId: (applicationId: string | number) => ({
          'files': {
            _fileId: (fileId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/members/applications/hifuyoushashikakukakunin/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/members/applications/hifuyoushashikakukakunin/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
            }),
          },
        }),
      },
      'hihuyousyaidoutodoke': {
        _applicationId: (applicationId: string | number) => ({
          'files': {
            _fileId: (fileId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/members/applications/hihuyousyaidoutodoke/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/members/applications/hihuyousyaidoutodoke/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
            }),
          },
        }),
      },
      'ryoyohitatekae': {
        _applicationId: (applicationId: string | number) => ({
          'files': {
            _fileId: (fileId: string | number) => ({
              $url: (url?: { hash?: string }) => ({ pathname: '/members/applications/ryoyohitatekae/[applicationId]/files/[fileId]' as const, hash: url?.hash, path: pathInterceptor(`/members/applications/ryoyohitatekae/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}${buildSuffix(url)}`) }),
            }),
          },
        }),
      },
    },
    'auth': {
      'email_change_callback': {
        $url: (url?: { hash?: string }) => ({ pathname: '/members/auth/email-change-callback' as const, hash: url?.hash, path: pathInterceptor(`/members/auth/email-change-callback${buildSuffix(url)}`) }),
      },
    },
    'digital_identification_auth': {
      'callback': {
        $url: (url?: { hash?: string }) => ({ pathname: '/members/digital-identification-auth/callback' as const, hash: url?.hash, path: pathInterceptor(`/members/digital-identification-auth/callback${buildSuffix(url)}`) }),
      },
    },
    'insurance_card': {
      'eligibility_loss_certificate': {
        _insuranceNumberId: (insuranceNumberId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/members/insurance-card/eligibility-loss-certificate/[insuranceNumberId]' as const, hash: url?.hash, path: pathInterceptor(`/members/insurance-card/eligibility-loss-certificate/${encodeURIComponent(insuranceNumberId)}${buildSuffix(url)}`) }),
        }),
      },
    },
    'zendesk': {
      'logout': {
        $url: (url?: { hash?: string }) => ({ pathname: '/members/zendesk/logout' as const, hash: url?.hash, path: pathInterceptor(`/members/zendesk/logout${buildSuffix(url)}`) }),
      },
      'redirect': {
        $url: (url?: { hash?: string }) => ({ pathname: '/members/zendesk/redirect' as const, hash: url?.hash, path: pathInterceptor(`/members/zendesk/redirect${buildSuffix(url)}`) }),
      },
    },
  },
  'zendesk': {
    'logout': {
      $url: (url?: { hash?: string }) => ({ pathname: '/zendesk/logout' as const, hash: url?.hash, path: pathInterceptor(`/zendesk/logout${buildSuffix(url)}`) }),
    },
    'sso': {
      $url: (url?: { hash?: string }) => ({ pathname: '/zendesk/sso' as const, hash: url?.hash, path: pathInterceptor(`/zendesk/sso${buildSuffix(url)}`) }),
    },
  },
});

export type Path = ReturnType<typeof buildPaths>;
